module.exports = __webpack_public_path__ + "img/lionnix_logo.3ac2f510.png";